import { Box, Link, Typography } from '@mui/material'
import React from 'react'

const IdentityBox = ({ fullName, body, email, image }) => {
	return (
		<>
			<Box
				sx={{
					bgcolor: 'text.disabled',
					borderRadius: '50%',
					height: 112,
					width: 112,
					overflow: 'hidden',
					m: (theme) => theme.spacing(2, 'auto'),
					'& img': { width: '100%' },
				}}
			>
				<Typography dangerouslySetInnerHTML={{ __html: image }} />
			</Box>
			<Typography component="p" sx={{ fontSize: 16, fontWeight: 700, color: 'text.primary' }}>
				{fullName}
			</Typography>
			<Typography
				component="p"
				sx={{
					fontSize: 14,
					fontWeight: 400,
					color: 'text.primary',
					'& figure': { display: 'none' },
				}}
				dangerouslySetInnerHTML={{ __html: body }}
			></Typography>
			<Link href={`mailto:${email}`} color="secondary.main" sx={{ fontSize: 12, fontWeight: 400 }}>
				{email}
			</Link>
		</>
	)
}

export default IdentityBox
